/* eslint-disable */

export const checkEmail = (input) => {
  const regexp =
    /^(([^<>()[\]\\.,;:\s@"]+(\.+[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return regexp.test(input.toLowerCase());
};
